import React, { useState } from "react";
import Filter from "./Filter";
import { createContext } from "react";
import Result from "./Result";

export const DynamicChartContext = createContext({
  dataSource: [],
  loading: false,
  setDataSource: (data) => {},
  setLoading: (data) => {},
});

const DynamicChart = () => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);

  return (
    <DynamicChartContext.Provider
      value={{ dataSource, loading, setDataSource, setLoading }}
    >
      <div className="pt-0">
        <div className="px-8 pt-6 pb-4">
          <Filter />
        </div>

        <Result />
      </div>
    </DynamicChartContext.Provider>
  );
};

export default DynamicChart;
